import styles from './Spinner.module.scss'



const Spinner = () => {

    return (
        <div className={styles.loader}>

            Loading...

        </div>
    )
}

export default Spinner
